export const TypeIncomeProof = [
  { value: 1, text: "Persona Asalariada" },
  { value: 2, text: "Persona Independiente Formal" },
  { value: 3, text: "Persona No Asalariada" }
];

export const PURPOSE_RESOURCES = [
  { value: 717810000, text: "Ahorro o inversión" },
  { value: 717810001, text: "Adquirir un bien" },
  { value: 717810002, text: "Ahorro para el retiro" },
  { value: 717810003, text: "Pagar un producto de Crédito" },
  { value: 717810004, text: "Utilizar la Cuenta para pago a terceros" },
  { value: 717810005, text: "Pagar Servicios" },
  { value: 717810006, text: "Otros" }
];

export const CLIENTLOOKUP = [
  { id: 1, name: "RFC", length: 13 },
  { id: 2, name: "CURP", length: 18 },
  { id: 3, name: "Número de Cliente Libertad", length: 10 }
];
